module.exports = __webpack_public_path__ + "img/img1.d0290bcb.png";